<template>
  <v-app class="home-bg">
    <!--
    <v-img
      src="@/assets/photos/intro.jpg"
    ></v-img>
    -->
    <v-container
       v-if="!isLoggedIn"
       fill-height
       fluid
      >
      <v-row
        align="center"
        justify="center">
       <v-col cols="12" align="center">
        <div class="my-4">
          <v-btn
            x-large
            dark
            color="accent"
            :to="{ name: 'login' }"
          >
            <v-icon left>mdi-login</v-icon>
            Logga in
          </v-btn>
        </div>
        <div>
          <v-btn
            dark
            color="primary"
            :to="{ name: 'company-signup' }"
            class="ma-4"
          >
            Registrera åkeri
          </v-btn>
        </div>
        <div>
          <v-btn
            dark
            color="primary"
            :to="{ name: 'driver-signup' }"
            class="ma-4"
          >
            Registrera chaufför
          </v-btn>
        </div>
        <div style="height:181px;"></div>
       </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: "Home",
  computed: {
    ...mapGetters(['isLoggedIn', 'agentType'])
  },
  methods: {
  }
}
</script>
<style scoped>
  .home-bg {
    background-image: url('~@/assets/photos/chaffis_woman_ipad.jpg');
    background-position: center;
    background-size: cover;
  }
</style>